/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Order_Recreate_GiftInputs */

const vi_error_order_recreate_gift = /** @type {(inputs: Error_Order_Recreate_GiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn quà từ website / Mini App không huỷ để tạo lại được — sẽ mất lời nhắn, ẩn giá và ship người đặt đã trả trước. Sửa đơn tại chỗ hoặc huỷ rồi báo khách đặt lại.`)
};

/**

* @param {Error_Order_Recreate_GiftInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_order_recreate_gift = /** @type {((inputs?: Error_Order_Recreate_GiftInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Order_Recreate_GiftInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_order_recreate_gift(inputs)
});